import React from 'react';
import { Modal, ModalBody, Button, Spinner } from 'reactstrap';

const SubmitConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Submission',
  message,
  confirmLabel = 'Yes, Submit',
  cancelLabel = 'Cancel',
  isSubmitting = false,
  showConfirm = true,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
    centered
    className='border-0 rounded-4'
  >
    <ModalBody className='p-0'>
      <div className='text-center px-4 pt-5 pb-4'>
        <div
          className='bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4'
          style={{ width: '80px', height: '80px' }}
        >
          <i className='bx bx-folder fs-1 text-white'></i>
        </div>

        <h4 className='fw-bold text-dark mb-2'>
          {title || 'Confirm Submission'}
        </h4>

        <p
          className='text-muted fs-14 px-3 mb-0'
          style={{ whiteSpace: 'pre-line' }}
        >
          {message ||
            'Are you sure you want to submit? This action cannot be undone.'}
        </p>
      </div>

      <div className='border-top d-flex align-items-center justify-content-between p-3 bg-white rounded-bottom-4'>
        <Button
          color='link'
          onClick={onClose}
          disabled={isSubmitting}
          className='text-decoration-none text-primary fw-semibold px-4'
        >
          {cancelLabel || 'Cancel'}
        </Button>

        {showConfirm && (
          <Button
            color='primary'
            onClick={onConfirm}
            disabled={isSubmitting}
            className='px-5 py-2 fw-semibold rounded-3'
            style={{ minWidth: '160px' }}
          >
            {isSubmitting ? <Spinner size='sm' /> : confirmLabel || 'Submit'}
          </Button>
        )}
      </div>
    </ModalBody>
  </Modal>
);

export default SubmitConfirmModal;
